<ng-container
  *ngIf="
    !divergentPricesOnly &&
    !baseProject.invoiceAsNonExecuted &&
    (price | nullCheck)
  "
>
  <td class="id"></td>
  <td class="date"></td>
  <td class="description">
    {{ description }}
  </td>
  <td class="price">
    {{ price | multiply: distinctCompanyFactor | asFormatDecimal: true:2 }}
    €
  </td>
</ng-container>
